module.exports = __webpack_public_path__ + "img/academico.21b7143d.svg";